import { render, staticRenderFns } from "./Cadastro-Usuarios-Editar.vue?vue&type=template&id=11274cb0&"
import script from "./Cadastro-Usuarios-Editar.vue?vue&type=script&lang=js&"
export * from "./Cadastro-Usuarios-Editar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Cadastro-Usuarios-Editar.vue"
export default component.exports